export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9853.1976c3c4.jpg";